import "../dasboard-component/MainDashboard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
function textAd({
  adsSelected,
  currentAdIndexes,
  selectedAd,
  handleClicks,
  preview,
  slot,
}) {
  return (
    <div>
      {/* Text Ad Section */}
      {(adsSelected[slot]?.[currentAdIndexes[slot]]?.iterations > 0 ||
        (!adsSelected[slot] && preview === "text")) && (
        <div
          onClick={(e) =>
            handleClicks(e, adsSelected[slot]?.[currentAdIndexes[slot]])
          }
          data-id={`ad-${slot}`}
          className={`max-w-3xl mx-auto bg-white shadow-md rounded-2xl mb-3 px-2 py-3 md:px-4 md:py-3 flex items-center justify-between border border-gray-200 ${
            selectedAd === `ad-${slot}`
              ? "border-red-500 shadow-lg animate-pulse"
              : "border-gray-200 shadow-sm"
          }`}
        >
          {/* Text Section */}
          <div className="flex-1">
            <h3 className="text-[0.8rem] md:text-[1rem] font-semibold text-gray-900">
              {
                adsSelected[slot]?.[currentAdIndexes[slot]]?.text
                  ?.split("\n\n")[0]
                  .split(" ")[0]
              }{" "}
              <span className="text-gray-500 mb-2 font-normal">
                {adsSelected[slot]?.[currentAdIndexes[slot]]?.text
                  ?.split("\n\n")[0]
                  .split(" ")
                  .slice(1)
                  .join(" ")}
              </span>
            </h3>
            <p className="text-[0.5rem] md:text-[0.7rem] text-gray-500 mb-2">
              {
                adsSelected[slot]?.[currentAdIndexes[slot]]?.text?.split(
                  "\n\n"
                )[1]
              }
            </p>
          </div>

          {/* CTA Button (hidden on mobile) */}
          <div className="ml-6 hidden md:block">
            <button className="bg-blue-600 text-xs hover:bg-blue-700 text-white font-medium px-5 py-2 rounded-lg shadow">
              Learn More
            </button>
          </div>
        </div>
      )}
    </div>

    // <div className="max-w-3xl mx-auto bg-white shadow-md rounded-2xl mb-3 px-2 py-3 md:px-4 md:py-3 flex items-center justify-between border border-gray-200">
    //   {/* Text Section */}
    //   <div className="flex-1">
    //     <h3 className="text-[0.8rem] md:text-[1rem] font-semibold text-gray-900">
    //       Dummy{" "}
    //       <span className="text-gray-500 mb-2 font-normal">
    //         Ad Title Goes Here
    //       </span>
    //     </h3>
    //     <p className="text-[0.5rem] md:text-[0.7rem] text-gray-500 mb-2">
    //       This is some dummy ad text content for preview purposes only. Replace
    //       this later with real ad data.
    //     </p>
    //   </div>

    //   {/* CTA Button */}
    //   <div className="ml-6 md:block hidden">
    //     <button className="bg-blue-600 text-xs hover:bg-blue-700 text-white font-medium px-5 py-2 rounded-lg shadow">
    //       Learn More
    //     </button>
    //   </div>
    // </div>
  );
}

export default textAd;
